<template>
  <b-form-group class label="Month" label-for="monthFilter">
    <v-select
      id="monthFilter"
      v-model="selectedMonth"
      class="filter disableClear"
      :options="months"
      :select-on-tab="true"
      @input="SetSelectedMonth"
    />
  </b-form-group>
</template>

<script>
  import vSelect from "vue-select";
  import { DateAndTimeService } from "@/services/DateAndTimeService";
  import { ErrorLogService } from "@/services/ErrorLogService";

  export default {
    components: {
      vSelect
    },
    props: {
      numberOfMonths: {
        default: 0
      },
      value: {
        type: String,
        required: false
      }
    },
    data: () => ({
      months: [],
      selectedMonth: ""
    }),
    created() {
      this.selectedMonth = this.value || "Choose a Month";
      DateAndTimeService.GetAvailableMonths(this.numberOfMonths)
        .then(availableMonthsDto => {
          this.months = availableMonthsDto.data;
        })
        .catch(err => {
          ErrorLogService.LogException(err);
        });
    },
    methods: {
      SetSelectedMonth: function(selectedAvailableDealerCode) {
        this.$emit("selectMonth", this.selectedMonth);
      }
    }
  };
</script>
